import baseApi from "store/api/baseApi";

const developerManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAllDevelopers: builder.query({
      query: () => "qwikITUser/",
      providesTags: ["developers"],
      transformResponse: response => response.filter(user => user.role === "developer"),
    }),
    getAllDesigners: builder.query({
      query: () => "qwikITUser/",
      providesTags: ["designers"],
      transformResponse: response => response.filter(user => user.role === "designer"),
    }),
    getAllProjectManagers: builder.query({
      query: () => "qwikITUser/",
      providesTags: ["projectManagers"],
      transformResponse: response => response.filter(user => user.role === "project_manager"),
    }),
  }),
});

export const {
  useGetAllDevelopersQuery,
  useGetAllDesignersQuery,
  useGetAllProjectManagersQuery,
} = developerManagementApi;





// const developerManagementApi = baseApi.injectEndpoints({
//   endpoints: builder => ({
//     getAllDevelopers: builder.query({
//       query: () => ({
//         url: "qwikITUser/",
//         method: "GET",
//       }),
//       providesTags: ["developers"],
//       transformResponse: response => response.filter(user => user.role === "developer"),
//     }),
//   }),
// });

// export const { useGetAllDevelopersQuery } = developerManagementApi;

